import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg"

function FavorisInactif(props) {
    return (
        <Svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} fill="none" viewBox="0 0 35 35" {...props}>
            <Rect width={35} height={35} fill="#fff" rx={7} />
            <G clipPath="url(#clip0_37:444)">
                <Path
                    stroke={baseColors.green.primary}
                    d="M24.23 15.704h0l-4.33-.394-.298-.027-.117-.274-1.71-4.006h-.001a.298.298 0 00-.547 0h0l-1.712 4.006-.117.274-.297.027-4.33.393s0 0 0 0a.299.299 0 00-.17.522s0 0 0 0l3.273 2.87.224.196-.066.29-.965 4.25s0 0 0 0a.297.297 0 00.116.308v.001a.294.294 0 00.326.014h0l3.734-2.232.257-.154.256.154 3.733 2.232s0 0 0 0c.103.061.23.056.328-.014h0a.297.297 0 00.115-.308s0 0 0 0l-.965-4.25-.066-.291.224-.196 3.273-2.87-.168-.521zm0 0c.118.01.218.09.255.204m-.255-.204l.255.204m0 0a.298.298 0 01-.087.317l.087-.317z"
                />
            </G>
            <Defs>
                <ClipPath id="clip0_37:444">
                    <Path fill="#fff" d="M0 0h15v15H0z" transform="translate(10 10)" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default FavorisInactif
